<template>
  <svg
    :class="computedClass"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="9" :stroke="color" stroke-width="1.5" />
    <path d="M3 12H21" :stroke="color" stroke-width="1.5" />
    <path
      d="M12 3C12 3 8 7 8 12C8 17 12 21 12 21"
      :stroke="color"
      stroke-width="1.5"
    />
    <path
      d="M12 3C12 3 16 7 16 12C16 17 12 21 12 21"
      :stroke="color"
      stroke-width="1.5"
    />
  </svg>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
  size?: number | string;
  color?: string;
  class?: string;
}

const props = withDefaults(defineProps<Props>(), {
  size: 24,
  color: "currentColor",
  class: "",
});

const computedClass = computed(() => props.class);
</script>
